import yn from "yn";
import useUserPermission from "~/hooks/useUserPermission";

// The Cohort Explorer feature is gated behind the VITE_COHORT_EXPLORER_ENABLED
// build flag and the `view:cohort-explorer-config-app` functional permission.
// This is the feature-level gate shared by the Cohort Explorer config view and
// the dataset Access Requests view; per-dataset access is layered on top in
// useCanViewCohortExplorer.
export const useCohortExplorerEnabled = (): boolean => {
  const hasPermission = useUserPermission("view:cohort-explorer-config-app");
  return yn(import.meta.env.VITE_COHORT_EXPLORER_ENABLED, { default: false }) && hasPermission;
};
